import * as React from "react";

export const CardGridList = ({ children }) => {
    return (
        <ul className="gap-4 grid grid-cols-2 max-w-6xl md:grid-cols-4 sm:grid-cols-3 xl:grid-cols-5">
            {children}
        </ul>
    );
};
